import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { debounce } from 'lodash-es';

import { MatterService } from '../../core/services/matter.service';
import { PagingOptions } from '../../core/models/paged-options';
import { PagedList } from '../../core/models/paged-list';
import { Matter } from '../../core/models/matter';
import { MatTableDataSource } from '@angular/material/table';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { Router } from '@angular/router';

@Component({
  selector: 'app-matters-page',
  templateUrl: './matters-page.component.html',
  styleUrl: './matters-page.component.scss',
})
export class MattersPageComponent implements AfterViewInit {

  loading = true;
  pagedMatters?: PagedList<Matter> | undefined;

  debouncedSearch: _.DebouncedFunc<(pagedRequest?: PagingOptions | undefined) => void>;

  defaultPagedRequest = { pageSize: 10, pageNumber: 1 };
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  search = new FormControl('');

  constructor(private matterService: MatterService, private router: Router) {
    this.debouncedSearch = debounce(this.searchMatters, 300);
  }

  ngAfterViewInit() {
    this.searchMatters(this.defaultPagedRequest);
  }

  searchMatters(pagedRequest: PagingOptions | undefined = undefined) {
    pagedRequest ??= {
      pageNumber: this.paginator.pageIndex + 1,
      pageSize: this.paginator.pageSize
    };
    this.loading = true;

    this.matterService.getMatters(pagedRequest, true).subscribe((pagedResults) => {
      this.pagedMatters = pagedResults;
      this.loading = false;
    });
  }

  handlePageEvent(e: PageEvent) {
    this.searchMatters({
      pageSize: e.pageSize,
      pageNumber: e.pageIndex + 1
    });
  }


}
